import { render, staticRenderFns } from "./TargetPrizeImage.vue?vue&type=template&id=29829b6e&scoped=true&"
import script from "./TargetPrizeImage.vue?vue&type=script&lang=js&"
export * from "./TargetPrizeImage.vue?vue&type=script&lang=js&"
import style0 from "./TargetPrizeImage.vue?vue&type=style&index=0&id=29829b6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29829b6e",
  null
  
)

export default component.exports